import { UtilityMethods } from "@mindmemobile/mm-shared-global";
import { PaymentMethodPriority, PaymentMethodType } from "../enums";
import { IAPIPaymentBankModel, IAPIPaymentCardModel, IAPIPaymentMethodModel } from "../interfaces";
import { AddressModel } from "./AddressModel";
import { MerchantAccount } from "../..";


export class PaymentMethodModel {
    id: string;
    isDefault: boolean;
    card?: PaymentCardModel | null;
    type: keyof typeof PaymentMethodType;
    priority: keyof typeof PaymentMethodPriority;
    contactId: string;
    bank?: PaymentBankDModel | null;
    merchantAccount?: MerchantAccount
    constructor(data?: Partial<PaymentMethodModel>) {
        this.id = data?.id || '';
        this.isDefault = data?.isDefault == true;
        this.card = data?.card && new PaymentCardModel(data.card);
        this.type = data?.type || PaymentMethodType.Card;
        this.priority = data?.priority || PaymentMethodPriority.None;
        this.contactId = data?.contactId || '';
        this.bank = data?.bank && new PaymentBankDModel(data.bank);
        this.merchantAccount = data?.merchantAccount && new MerchantAccount(data.merchantAccount);
    }

    static deserializeAPIModel(data: IAPIPaymentMethodModel): PaymentMethodModel {
        const mappedData: Partial<PaymentMethodModel> = {
            id: data?.id,
            isDefault: data?.isDefault,
            type: data?.type as keyof typeof PaymentMethodType,
            card: data.card && PaymentCardModel.deserializeAPIModel(data?.card),
            priority: data?.priority as keyof typeof PaymentMethodPriority,
            contactId: data?.contactId,
            bank: data.bank && PaymentBankDModel.deserializeAPIModel(data?.bank),
            merchantAccount: data.merchantAccount && MerchantAccount.deserializeAPIModel2(data?.merchantAccount)
        };
        return new PaymentMethodModel(mappedData);
    }

    static getDefaultSelecedPaymentMethod(paymentMethods: PaymentMethodModel[], contactId: string, gatewayMerchantAccountId: string): PaymentMethodModel | undefined {
        const primaryPaymentMethod = paymentMethods.find(
            (paymentMethod) =>
                paymentMethod.priority === PaymentMethodPriority.Primary &&
                paymentMethod.contactId &&
                paymentMethod.contactId === contactId &&
                paymentMethod.merchantAccount?.merchantAccountId === gatewayMerchantAccountId
        );
        const nonPrimaryMethod = paymentMethods.find(
            (paymentMethod) => paymentMethod.contactId && paymentMethod.contactId === contactId && paymentMethod.merchantAccount?.merchantAccountId === gatewayMerchantAccountId
        );
        return primaryPaymentMethod || nonPrimaryMethod;
    }
}

export class PaymentCardModel {
    gatewayCardId: string;
    brand: string;
    type: string;
    last4: string;
    expiryDate: Date;
    expiryMonth: string;
    expiryYear: string;
    cvvCheck: boolean;
    cardHolderName: string;
    address?: AddressModel;
    addressZipCheck: boolean;
    constructor(data?: Partial<PaymentCardModel>) {
        this.gatewayCardId = data?.gatewayCardId || '';
        this.brand = data?.brand || '';
        this.type = data?.type || '';
        this.last4 = data?.last4 || '';
        this.expiryDate = data?.expiryDate || new Date();
        this.expiryMonth = data?.expiryMonth || '';
        this.expiryYear = data?.expiryYear || '';
        this.cvvCheck = data?.cvvCheck === true;
        this.cardHolderName = data?.cardHolderName || '';
        this.addressZipCheck = data?.addressZipCheck === true;
        this.address = data?.address && new AddressModel(data?.address);
    }

    static deserializeAPIModel(data: IAPIPaymentCardModel): PaymentCardModel {
        if (!data) {
            return new PaymentCardModel();
        }
        const mappedData: Partial<PaymentCardModel> = {
            gatewayCardId: data?.gatewayCardId && data?.gatewayCardId,
            brand: data?.brand && data?.brand,
            type: data?.type && data?.type,
            last4: data?.last4 && data?.last4,
            expiryDate: data?.expiryDate ? UtilityMethods.removeZFromDateString(data?.expiryDate) : new Date(),
            expiryMonth: data?.expiryMonth && data?.expiryMonth,
            expiryYear: data?.expiryYear && data?.expiryYear,
            cvvCheck: data?.cvvCheck && data?.cvvCheck === true,
            cardHolderName: data?.cardHolderName && data?.cardHolderName,
            addressZipCheck: data?.addressZipCheck && data?.addressZipCheck === true,
            address: data?.address && AddressModel.deserializeAPIModel(data?.address),
        };
        return new PaymentCardModel(mappedData);
    }
}

export class PaymentBankDModel {
    maskedAccount: string;
    maskedRouting: string;
    name: string;
    ownerType: string;
    subType: string;
    constructor(data?: Partial<PaymentBankDModel>) {
        this.maskedAccount = data?.maskedAccount || '';
        this.maskedRouting = data?.maskedRouting || '';
        this.name = data?.name || '';
        this.ownerType = data?.ownerType || '';
        this.subType = data?.subType || '';
    }

    static deserializeAPIModel(data: IAPIPaymentBankModel): PaymentBankDModel {
        const mappedData: Partial<PaymentBankDModel> = {
            maskedAccount: data.maskedAccount,
            maskedRouting: data.maskedRouting,
            name: data.name,
            ownerType: data.ownerType,
            subType: data.subType,
        };
        return new PaymentBankDModel(mappedData);
    }
}
